import { render } from "./LbrxDisplayHeader.vue?vue&type=template&id=6e003423&scoped=true"
import script from "./LbrxDisplayHeader.vue?vue&type=script&lang=js"
export * from "./LbrxDisplayHeader.vue?vue&type=script&lang=js"

import "./LbrxDisplayHeader.vue?vue&type=style&index=0&id=6e003423&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e003423"]])

export default __exports__